import {createAction} from "@reduxjs/toolkit";

export const ELECTION_ACTION_TYPES = {
  SET_ELECTION_ID: 'SET_ELECTION_ID',
};
export const setElectionId = createAction<string>(ELECTION_ACTION_TYPES.SET_ELECTION_ID);
